export const UPDATE_TIME = "general/UPDATE_TIME";
